//Overall
export const CHECKIFPLUGIN = (state, val) => {
  state.isPlugin = val;
}
export const CHECKIFAGENT = (state, val) => {
  state.isAgent = val;
}

export const LOGIN = (state) => {
      state.logged = 1;
}

export const SETCURRENTUSER = (state, obj) => {

  state.currentUser.login = obj.login;
  state.currentUser.role = obj.role;
  state.currentUser.userId = obj.userId;
}

export const SETUSERFULLNAME = (state, value) => {

  state.currentUser.fullName = value;
  
}

export const LOGOUT = (state) => {
  state.logged = 0;
}

export const SELECTUSER = (state, obj) => {

  state.selectedUser = Object.assign({}, state.selectedUser, obj)
}

export const USERSQUANTITY = (state, value) => {

  state.usersQuantity = value;
}

export const SETLANG = (state, obj) => {

  state.langVariant = Object.assign({}, state.langVariant, obj);
}

export const S_LIC = (state, obj) => {
  state.appConf.status = obj;
  
}
export const S_GLOBALSETTINGS = (state, obj) => {

  state.globalSettings = Object.assign({}, state.globalSettings, obj)
  
}
export const S_BUILD = (state, obj) => {
  state.appConf.build = obj.build;
  state.appConf.buildAgentUpdate = obj.buildAgentUpdate;
}


export const GOTO = (state, obj) => {

  state.goToObject = Object.assign({}, state.goToObject, obj)
}

export const SETSECONDLEVEL = (state, arr) => {
  
  state.isSecondLevel = false;
  for (let i = 0, lei = arr.length; i < lei; i++){
    if (arr[i].isSecondLevel == true) {
      state.isSecondLevel = true;
      break;
    }
  }
  
  
  
}



export const SHOWALERT = (state, obj) => {
  state.isAlert = true;
  state.alertObject = Object.assign({}, state.alertObject, obj)
}

export const HIDEALERT = (state) => {
  state.isAlert = false;
}

export const SHOWLOADER = (state, obj) => {
  
  state.loader = Object.assign({}, state.loader, obj);
}

export const SHOWMODALCOMPONENT = (state, obj) => {
  state.isModalComponent = true;

  state.modalComponentObject = Object.assign({}, state.modalComponentObject, obj)

}

export const SETBUTTONSTATEMODALCOMPONENT = (state, obj) => {
  state.buttonsStateModalObject = Object.assign({}, state.buttonsStateModalObject, obj)
}

export const HIDEMODALCOMPONENT = (state) => {
  state.isModalComponent = false;
}


export const SHOWMODALSEARCHPARTSCOMPONENT = (state, obj) => {
  state.isModalSearchPartsComponent = true;

  state.modalSearchPartsComponentObject = Object.assign({}, state.modalSearchPartsComponentObject, obj)

}

export const HIDEMODALSEARCHPARTSCOMPONENT = (state) => {
  state.isModalSearchPartsComponent = false;
}

export const SETALERTCONTAINER = (state, obj) => {
  state.alertContainer = Object.assign({}, state.alertContainer, obj)
}

export const SHOWSETTINGS = (state) => {
  state.isSettings = true;
}

export const HIDESETTINGS = (state) => {
  state.isSettings = false;
}

export const SETALERT = (state, value) => {

  state.alertTable.push(value);
}

export const GETNOTIFICATIONS = (state, value) => {

  state.dataNotifications = Object.assign({}, state.dataNotifications, value)

}



export const SETOUTERDATA = (state, value) => {

  state.outerData = value;
  
}

export const SETVIEW = (state, value) => {

  state.viewForModule = value;

}

export const SETSECTIONPREFIX = (state, value) => {

  state.sectionPrefix = value;

}

export const SETFILTEREDDATA = (state, value) => {

  state.filteredData = value;

}

//S - Settings

export const S_CHANGESKINVARIANTS = (state, value) => {


    state.s_skinVariant = value;

    //var bgColor, textColor;
    var thisClass = "app cadfm-container-vertical";
 

    switch(value)
    {
      case "light":

        thisClass += " --light";
        break;
      case "dark":

        thisClass += " --dark";
        break;
      case "custom":

        thisClass += " --custom";
        break;
    }
    //document.querySelector('html').style.setProperty('background-color', bgColor);
    //document.querySelector('html').style.setProperty('color', textColor);
    document.getElementById("app").className = thisClass;
    //document.querySelector("svg icon").className = clas;


}

// Users

export const CREATEUSERFORM = (state, obj) => {

  state.createUserForm = Object.assign({}, state.createUserForm, obj)
}

//permissions

export const CREATEGROUPFORM = (state, obj) => {

  state.createGroupForm = Object.assign({}, state.createGroupForm, obj)
}

export const SETPERMISSIONGROUP = (state, arr) => {

  state.permissionGroup = arr;
}

//All
export const SETSAVESTATUS = (state, value) => {

  state.saveStatus = value;
}


export const GETDATATREE = (state, value) => {

  state.dataTree = Object.assign({}, state.dataTree, value)
}
export const GETSEARCHPARTSDATATREE = (state, value) => {

  state.dataSearchPartsTree = Object.assign({}, state.dataSearchPartsTree, value)
}
export const SELECTTREEITEM = (state, value) => {

  state.selectedTreeItem = value;
}
export const SELECTTREEITEMOBJECT = (state, value) => {

  state.selectedTreeItemObject = value;
}
export const SELECTSEARCHPARTSTREEITEM = (state, value) => {

  state.selectedSearchPartsTreeItem = value;
}
export const SELECTSEARCHPARTSTREEITEMOBJECT = (state, value) => {

  state.selectedSearchPartsTreeItemObject = value;
}
export const RELOADAFTERDELETETREEITEM = (state, value)=>{
  state.reloadAfterDeleteTreeItem = value;
}

export const EXTERNALSEARCHRESPONSE = (state, obj)=>{

  
  state.externalSearchResponseResult = obj;
}

export const SETSELECTEDSEARCHEDROWS = (state, obj) => {
  state.selectedSearchedRows = Object.assign({}, state.selectedSearchedRows, obj)
}
export const DELETESELECTEDSEARCHEDROWS = (state) => {
  state.selectedSearchedRows = {}
}

export const PM_ADDACTIVEFILTER = (state, value) => {

  var index = state.pm_activeFilters.indexOf(value);
  if (index < 0) {
    state.pm_activeFilters.push(value);
  }

}

export const PM_DELETEACTIVEFILTER = (state, value) => {

  var index = state.pm_activeFilters.indexOf(value);

  if (index > -1) {
    state.pm_activeFilters.splice(index, 1);
  }

}

export const PM_DELETEALLACTIVEFILTERS = (state) => {

  state.pm_activeFilters = [];

}

export const PM_ADDACTIVEACTION = (state, obj) => {

  let trig = false;

  for (let i = 0, lei = state.pm_activeActions.length; i < lei; i++){
    if (state.pm_activeActions[i].actionId == obj.actionId){
      trig = true;
      break;
    }
  }
  if (trig == false) {
    state.pm_activeActions.push(obj);
  }

}

export const PM_DELETEACTIVEACTION = (state, obj) => {

  let index = null;
  for (let i = 0, lei = state.pm_activeActions.length; i < lei; i++){
      
    if (state.pm_activeActions[i].name == obj.name){
      index = i;
      break;
    }
  }

  if (index != null) {
    state.pm_activeActions.splice(index, 1);
  }

}

export const PM_DELETEALLACTIVEACTIONS = (state) => {

  state.pm_activeActions = [];

}

export const LM_ADDACTIVEFILTER = (state, value) => {

  var index = state.lm_activeFilters.indexOf(value);
  if (index < 0) {
    state.lm_activeFilters.push(value);
  }

}

export const LM_DELETEACTIVEFILTER = (state, value) => {

  var index = state.lm_activeFilters.indexOf(value);

  if (index > -1) {
    state.lm_activeFilters.splice(index, 1);
  }

}

export const LM_DELETEALLACTIVEFILTERS = (state) => {

  state.lm_activeFilters = [];

}

export const LM_ADDACTIVEACTION = (state, obj) => {

  let trig = false;

  for (let i = 0, lei = state.lm_activeActions.length; i < lei; i++){
    if (state.lm_activeActions[i].actionId == obj.actionId){
      trig = true;
      break;
    }
  }
  if (trig == false) {
    state.lm_activeActions.push(obj);
  }

}

export const LM_DELETEACTIVEACTION = (state, obj) => {

  let index = null;
  for (let i = 0, lei = state.lm_activeActions.length; i < lei; i++){
      
    if (state.lm_activeActions[i].name == obj.name){
      index = i;
      break;
    }
  }

  if (index != null) {
    state.lm_activeActions.splice(index, 1);
  }

}

export const LM_DELETEALLACTIVEACTIONS = (state) => {

  state.lm_activeActions = [];

}

export const SETLIBSTATUSES = (state, arr) => {
  state.libStatuses = arr;
}


export const PROJM_ADDACTIVEFILTER = (state, value) => {

  var index = state.projm_activeFilters.indexOf(value);
  if (index < 0) {
    state.projm_activeFilters.push(value);
  }

}

export const PROJM_DELETEACTIVEFILTER = (state, value) => {

  var index = state.projm_activeFilters.indexOf(value);

  if (index > -1) {
    state.projm_activeFilters.splice(index, 1);
  }

}

export const PROJM_DELETEALLACTIVEFILTERS = (state) => {

  state.projm_activeFilters = [];

}

export const PROJM_ADDACTIVEACTION = (state, obj) => {

  let trig = false;

  for (let i = 0, lei = state.projm_activeActions.length; i < lei; i++){
    if (state.projm_activeActions[i].actionId == obj.actionId){
      trig = true;
      break;
    }
  }
  if (trig == false) {
    state.projm_activeActions.push(obj);
  }

}

export const PROJM_DELETEACTIVEACTION = (state, obj) => {

  let index = null;
  for (let i = 0, lei = state.projm_activeActions.length; i < lei; i++){
      
    if (state.projm_activeActions[i].name == obj.name){
      index = i;
      break;
    }
  }

  if (index != null) {
    state.projm_activeActions.splice(index, 1);
  }

}

export const PROJM_DELETEALLACTIVEACTIONS = (state) => {

  state.projm_activeActions = [];

}

export const SETELEMENTCATEGORY = (state, value) => {

  state.elementCategorySearchParts = value;
}
export const SETSEARCHPARTSELEMENTCATEGORY = (state, value) => {

  state.elementCategory = value;
}

export const SETAUTHORITYTOCHANGE = (state, value) => {

  state.authorityToChange = value;
}

export const GETDATA = (state, value) => {

  state.dataTable = Object.assign({}, state.dataTable, value)
}

export const SETSELECTEDROWS = (state, obj) => {


  if (state.selectedRows.length == 0){
    
    state.selectedRows.push(obj);
  }else{
    let trig = false;
    for (var i = 0, len = state.selectedRows.length; i < len; i++){

      if (obj.col___revisionId.revisionId == state.selectedRows[i].col___revisionId.revisionId){
        trig = true;
        
      }
    }
    if (trig == false){
      
      state.selectedRows.push(obj);
    }
  }
  
  

}

export const DELETESELECTEDROWS = (state, value) => {

  for (var i = 0, len = state.selectedRows.length; i < len; i++){

    if (value.col___revisionId.revisionId == state.selectedRows[i].col___revisionId.revisionId){
      state.selectedRows.splice(i, 1);
      break;
    }
  }

}

export const DELETEALLSELECTEDROWS = (state) => {

  state.selectedRows = [];

}

// export const SETSELECTEDROWSSEARCH = (state, value) => {

//   state.selectedRowsSearch.push(value);

// }

// export const DELETESELECTEDROWSSEARCH = (state, value) => {

//   for (var i = 0, len = state.selectedRowsSearch.length; i < len; i++){

//     if (value[0][0].key == state.selectedRowsSearch[i][0][0].key){
//       state.selectedRowsSearch.splice(i, 1);
//       break;
//     }
//   }

// }

// export const DELETEALLSELECTEDROWSSEARCH = (state) => {

// state.selectedRowsSearch = [];

// }

export const GETFILTERS = (state, value) => {

  state.filters = Object.assign({}, state.filters, value)

}

export const GETREVISIONHISTORY = (state, value) => {

  state.revisionHistory = value;
}

export const GETDETAILS = (state, value) => {

  state.detailsData = Object.assign({}, state.detailsData, value)
}

export const GETFORMDETAILS = (state, value) => {

  state.formDetailsData = Object.assign({}, state.formDetailsData, value)
}

export const SELECTREVISIONROW = (state, obj) => {

  state.selectedRevisionRow.push(obj)

  function compare( a, b ) {
    if ( a.revision > b.revision ){
      return -1;
    }
    if ( a.revision < b.revision ){
      return 1;
    }
    return 0;
  }

  state.selectedRevisionRow.sort(compare);

}

export const DESELECTREVISIONROW = (state, obj) => {


  for (var i = 0, len = state.selectedRevisionRow.length; i < len; i++){

    if (obj.revisionId == state.selectedRevisionRow[i].revisionId){
      state.selectedRevisionRow.splice(i, 1);
      break;
    }
  }
}

export const DESELECTALLREVISIONROW = (state) => {

  state.selectedRevisionRow = []

}

export const SELECTFORMROW = (state, value) => {

  state.selectedFormRow.push(value)
}

export const DESELECTFORMROW = (state, value) => {


  for (var i = 0, len = state.selectedFormRow.length; i < len; i++){
/*
    if (value[0][0].key == state.selectedFormRow[0][0][i].key){
      state.selectedFormRow.splice(i, 1);
      break;
    }
*/
    state.selectedFormRow = []
  }
}

export const DESELECTALLFORMROW = (state) => {

  state.selectedFormRow = []

}

export const SETFORMTABLEINSTANCE = (state, value) => {

  state.formTableInstance = value;
}

export const SELECTINDEXFORMROW = (state, value) => {

  state.selectedIndexFormRow = value
}

export const DELETEINDEXFORMROW = (state) => {

  state.selectedIndexFormRow = ""

}

export const SETTERFORMDETAILSDATA = (state, obj) => {



  state.formDetailsData.data[obj.index][2].display = obj.value
  state.formDetailsData.data[obj.index][2].sort = obj.value
  state.formDetailsData.data[obj.index][2].filter = obj.value
  if (state.formDetailsData.data[obj.index][1] == "SCHEMATIC PART"){
    state.formDetailsData.data[obj.index][2].address = "/api/v3/partmanagement/parts/GetSchematicSvg/"+obj.value
  }else if (state.formDetailsData.data[obj.index][1] == "FOOTPRINT"){
    state.formDetailsData.data[obj.index][2].address = "/api/v3/partmanagement/parts/GetFootprintSvg/"+obj.value
  }

  //state.formDetailsData = Object.assign( state.formDetailsData.data[obj.index][2].display, obj.value)

}

export const SETFORMPROPERTY = (state, value) => {

  state.formProperty = value;
}

export const ADDPROPERTYTOSAVING = (state, obj) => {

  let trig = null;
  for (let i = 0, lei = state.propertyToSaving.length; i < lei; i++){

    if(obj.propertyId == state.propertyToSaving[i].propertyId){
      trig = i;
      break;

    }

  }
  
  if (trig != null){
    state.propertyToSaving[trig] = obj;
  }else{
    state.propertyToSaving.push(obj);
  }
  

}

export const ADDPROPERTYTOSAVINGUL = (state, obj) => {

  let trig = null;
  for (let i = 0, lei = state.propertyToSavingUL.length; i < lei; i++){

    if(obj.propertyId == state.propertyToSavingUL[i].propertyId){
      trig = i;
      break;

    }

  }
  
  if (trig != null){
    state.propertyToSavingUL[trig] = obj;
  }else{
    state.propertyToSavingUL.push(obj);
  }
  

}

export const RESETPROPERTYTOSAVINGUL = (state) => {

  state.propertyToSavingUL = [];

}

export const SELECTULCATEGORY = (state, obj) => {

  obj.name = state.libraryULObject.name;
  obj.type = state.libraryULObject.type;
  
  state.libraryULObject = Object.assign({}, state.libraryULObject, obj)

}
export const SETULLIBRARYNAME = (state, obj) => {

  obj.category = state.libraryULObject.category;
  obj.categoryId = state.libraryULObject.categoryId;

  state.libraryULObject = Object.assign({}, state.libraryULObject, obj)
}

export const ADDLIBRARYFILESTOSAVING = (state, obj) => {
  
  state.libraryFilesToSaving = obj;
    

}

export const RESETPROPERTYTOSAVING = (state) => {
 
  state.propertyToSaving = [];
}

export const RESETLIBRARYFILESTOSAVING = (state) => {
  
  state.libraryFilesToSaving = [];
}

export const EDITPROPERTIESFORM = (state, value) => {

  state.isEditPropertyForm = value;
}

export const SETPARTREVISIONID = (state, value) => {

  state.partRevisionId = value;
}

export const GETPINSTABLE = (state, value) => {

  state.pinsTable = Object.assign({}, state.pinsTable, value)
}

export const GETPINSTABLEDETAILS = (state, value) => {

  state.pinsTableDetails = Object.assign({}, state.pinsTableDetails, value)
}

export const GETDEPENDONTABLE = (state, value) => {

  state.dependOnTable = Object.assign({}, state.dependOnTable, value)
}

export const GETDEPENDONTABLEDETAILS = (state, value) => {

  state.dependOnTableDetails = Object.assign({}, state.dependOnTableDetails, value)
}

export const GETUSEINTABLE = (state, value) => {

  state.useInTable = Object.assign({}, state.useInTable, value)
}

export const GETUSEINTABLEDETAILS = (state, value) => {

  state.useInTableDetails = Object.assign({}, state.useInTableDetails, value)
}

export const GETTASKSTABLE = (state, arr) => {

  state.tasksTable = arr

  //state.tasksTable = Object.assign({}, state.tasksTable, value)
}

export const GETTASKSTABLEDETAILS = (state, value) => {

  state.tasksTableDetails = Object.assign({}, state.tasksTableDetails, value)
}

export const EVENTTASKRESPONSE = (state, value) => {

  state.eventTaskResponse = Object.assign({}, state.eventTaskResponse, value)

  //todo
  //reaction for accept event
  //or
  //reaction for reject event
}

export const GETPOSSIBLEVALUEFORCOMBO = (state, value) => {

  state.possibleValueForCombo = value
}

export const GETSEARCHEDPARTS = (state, value) => {

  state.dataTableSearched = Object.assign({}, state.dataTableSearched, value)
}

export const SETSEARCHINGOBJECT = (state, value) => {

  state.searchingObject = Object.assign({}, state.searchingObject, value)
}

export const GETPROCESSID = (state, value) => {

  state.processId = value.processId
}

export const DELETEPROCESSID = (state) => {

  state.processId = "";
}

export const SETPROCESSID = (state, value) => {

  state.processId = value;
}

// export const GETSYMBOLS = (state, value) => {

//   state.symbolsTable = Object.assign({}, state.symbolsTable, value)
// }

// export const GETFOOTPRINTS = (state, value) => {

//   state.footprintsTable = Object.assign({}, state.footprintsTable, value)
// }
export const ADDSELECTEDFOOTPRINTS = (state, obj) => {
  state.selectedFootprints = [];
  state.selectedFootprints.push(obj);
  
}
export const DELETESELECTEDFOOTPRINTS = (state) => {

  state.selectedFootprints = [];
}


export const ADDSELECTEDSYMBOLS = (state, obj) => {
  if (!state.selectedSymbols.includes(obj)){
    state.selectedSymbols.push(obj);
  }
  
}
export const DELETESELECTEDSYMBOLS = (state, obj) => {

  for (let i = 0, lei = state.selectedSymbols.length; i < lei; i++){
    if (state.selectedSymbols[i].symbolId == obj.symbolId){
      state.selectedSymbols.splice(i, 1);
      break;
    }
  }
  
}
export const DELETEALLSELECTEDSYMBOLS = (state, value) => {

  state.selectedSymbols = [];
  
}

export const ADDSELECTEDALTSYMBOLS = (state, obj) => {
  
  let trig = null;
  for (let i = 0, lei = state.selectedAltSymbols.length; i < lei; i++){

    if(obj.footprintId == state.selectedAltSymbols[i].footprintId){
      trig = i;
      break;

    }

  }
  
  if (trig != null){
    state.selectedAltSymbols[trig] = obj;
  }else{
    state.selectedAltSymbols.push(obj);
  }
    
}
export const DELETESELECTEDALTSYMBOLS = (state, obj) => {

  for (let i = 0, lei = state.selectedAltSymbols.length; i < lei; i++){
    if (state.selectedAltSymbols[i].footprintId == obj.footprintId){
      state.selectedAltSymbols.splice(i, 1);
      break;
    }
  }
  
}
export const DELETEALLSELECTEDALTSYMBOLS = (state, value) => {

  state.selectedAltSymbols = [];
  
}

export const SETCATEGORYMAPPING = (state, obj) => {

  state.categoryMapping.push(obj);
}

export const DELETECATEGORYMAPPING = (state) => {

  state.categoryMapping = [];
}

export const SETDERIVEDNEWPROPS = (state, arr) => {

  state.derivedNewProps = arr;
}

export const SETNEWSUBCATEGORY = (state, value) => {
  state.newSubCategory = value;
}

export const RENAMING = (state, obj) => {
  state.newRenamingValue = Object.assign({}, state.newRenamingValue, obj)
}
export const MOVING = (state, obj) => {
  state.newMovingCategory = Object.assign({}, state.newMovingCategory, obj)
}

export const DELEGATION = (state, obj) => {
  state.delegationForm = Object.assign({}, state.delegationForm, obj)
}

export const TRANSFEROWNERSHIP = (state, obj) => {
  state.transferOwnershipForm = Object.assign({}, state.transferOwnershipForm, obj)
}


//D - Dashboard
export const D_GETDASHBOARDWIDGETS = (state, value) => {

  state.d_dashboardWidgets = Object.assign({}, state.d_dashboardWidgets, value)

}

export const D_GETFILTEREDDATA = (state, value) => {


  var id = value.widget[0].widgetId;


  state.d_filteredData.splice(id, 1, value);

}

export const D_SETFILTEREDDATA = (state, value) => {


  state.d_filteredData[value] = {temp: ""};
}

export const D_SETWIDGETSSETTINGS = (state, obj) => {


  state.d_widgetsSettings = Object.assign({}, state.d_widgetsSettings, obj);
}

//PM - PartManager

export const SETPROPERTYID = (state, value) => {
  state.propertyId = value;
}
export const RELOADAFTERACTION = (state, obj) => {
  state.reloadedAfterAction = Object.assign({}, state.reloadedAfterAction, obj);
}

export const RELOADAFTERACTIONCOMPLEX = (state, obj) => {

  if (state.reloadedAfterActionComplex["counter"] === 999) {
    state.reloadedAfterActionComplex["counter"] = 0;
  }

  let trig = false;
  for (let el in state.reloadedAfterActionComplex) {
    if (state.reloadedAfterActionComplex[el].name == obj.name) {
     
      if (obj.status === false) {
        trig = true;
        delete state.reloadedAfterActionComplex[el]
               
      } 
      if (obj.status === true && state.reloadedAfterActionComplex[el].status === false) {
            
        state.reloadedAfterActionComplex["counter"]++;
        state.reloadedAfterActionComplex[obj.name] = Object.assign({}, state.reloadedAfterActionComplex[obj.name], obj);
    
      } 
    } 

  }
  if (trig === false) {
    
    state.reloadedAfterActionComplex["counter"]++;
    state.reloadedAfterActionComplex[obj.name] = Object.assign({}, state.reloadedAfterActionComplex[obj.name], obj);
    
  }
  
}

export const CREATEPROPERTYFORM = (state, obj) => {
  state.createPropertyForm = Object.assign({}, state.createPropertyForm, obj);
}

export const SETPREVIEWPARTS = (state, value) => {

  state.previewParts = value;
}

export const SETBOMPROPERTIES = (state, value) => {

  state.bomProperties = value;
}

export const SETIMPORTEDFILEID = (state, value) => {

  state.importedFileId = value;
}

export const RESETMAPFIELD = (state) => {

    state.mappedFields = [];

}

export const ADDMAPFIELD = (state, obj) => {

  for(let i = 0, lei = state.mappedFields.length; i < lei; i++){

    if (state.mappedFields[i].columnName == obj.columnName){

      state.mappedFields.splice(i, 1);
      break;
    }
  }
  if (obj.operationType != ""){
    state.mappedFields.push(obj);
  }


}

export const SETEVENTTASKFORM = (state, obj) => {

  state.eventTaskForm = Object.assign({}, state.eventTaskForm, obj);

}

export const ADDALTERNATIVEPART = (state, obj) => {

  state.alternativePartsToBind.push(obj);
  
}
export const DELETEALTERNATIVEPART = (state, obj) => {

  
  for (let i = 0, lei = state.alternativePartsToBind.length; i < lei; i++){
    if (state.alternativePartsToBind[i].distributorPartId == obj.distributorPartId){
      state.alternativePartsToBind.splice(i, 1);
      break;
    }
  }
 
}
export const DELETEALLALTERNATIVEPART = (state, obj) => {

  state.alternativePartsToBind = [];

}

export const SELECTALTERNATIVE = (state, obj) => {

  state.selectedAlternative = Object.assign({}, state.selectedAlternative, obj);
}

export const UNSELECTALTERNATIVE = (state) => {

  state.selectedAlternative = {};
}

export const SETALLACTIVEIMPORTEDPARTS = (state, obj) => {
  state.allActiveImportedParts = Object.assign({}, state.allActiveImportedParts, obj);
}

export const SETNOTIMPORTEDPARTS = (state, arr) => {

  state.notImportedParts = arr;
}

export const SETDUPLICATEPARTNUMBER = (state, value) => {

  state.duplicatePartNumber = value;
}

export const SETCURRENTSYMBOL = (state, obj) => {

  state.currentSymbol = Object.assign({}, state.currentSymbol, obj);
}

export const SETEXISTINGTYPES = (state, arr) => {

  state.existingTypes = arr;
}

export const CREATENEWASSEMBLYFORM = (state, obj) => {

  state.newAssemblyForm = Object.assign({}, state.newAssemblyForm, obj);
}

export const SETSELECTEDASSEMBLYROW = (state, obj) => {

  state.selectedAssemblyRow = Object.assign({}, state.selectedAssemblyRow, obj);
}

export const DELETESELECTEDASSEMBLYROW = (state) => {

  state.selectedAssemblyRow = {};
}

export const SETASSEMBLYQUANTITY = (state, value) => {

  state.assemblyQuantity = value;
}

export const SETTABSTATUS = (state, value) => {

  state.tabStatus = value;
}
//LM - LibraryManager

export const SETLIBRARYCATEGORYMAPPING = (state, obj) => {

  state.categoryLibraryMapping.push(obj);
}

export const DELETELIBRARYCATEGORYMAPPING = (state) => {

  state.categoryLibraryMapping = [];
}

export const GETDATATREELIBRARY = (state, value) => {

  state.dataLibraryTree = Object.assign({}, state.dataLibraryTree, value)
}
export const SELECTTREELIBRARYITEM = (state, value) => {

  state.selectedTreeLibraryItem = value;
}
export const SELECTTREELIBRARYITEMOBJECT = (state, value) => {

  state.selectedTreeLibraryItemObject = value;
}
export const RELOADAFTERDELETETREELIBRARYITEM = (state, value)=>{
  state.reloadAfterDeleteTreeLibraryItem = value;
}

export const SETELEMENTCATEGORYLIBRARY = (state, value) => {

  state.elementCategoryLibrary = value;
}


//P - ProcessesManager
export const P_SHOWPROCESSDIAGRAM = (state) => {

  state.p_showProcessDiagram = !state.p_showProcessDiagram;

}
//projm - Projects

export const SETPROJECTCATEGORYMAPPING = (state, obj) => {

  state.categoryProjectMapping.push(obj);
}

export const DELETEPROJECTCATEGORYMAPPING = (state) => {

  state.categoryProjectMapping = [];
}

export const GETDATATREEPROJECT = (state, value) => {

  state.dataProjectTree = Object.assign({}, state.dataProjectTree, value)
  
}
export const SELECTTREEPROJECTITEM = (state, value) => {

  state.selectedTreeProjectItem = value;
}
export const SELECTTREEPROJECTITEMOBJECT = (state, value) => {
 
  state.selectedTreeProjectItemObject = Object.assign({}, state.selectedTreeProjectItemObject, value)
}
export const RELOADAFTERDELETETREEPROJECTITEM = (state, value)=>{
  state.reloadAfterDeleteTreeProjectItem = value;
}

export const SETELEMENTCATEGORYPROJECT = (state, value) => {

  state.elementCategoryProject = value;
}

export const CREATEPROJECTFORM = (state, obj) => {

  state.createProjectForm = Object.assign({}, state.createProjectForm, obj)
}

export const SETSELECTEDPROJECTROW = (state, obj) => {

  state.selectedProjectRow = Object.assign({}, state.selectedProjectRow, obj)
  
}
export const DELETESELECTEDPROJECTROW = (state) => {
  
  state.selectedProjectRow = {};
  
}

export const SETBOMDESCRIPTION = (state, obj) => {
  
  state.bomDescription = Object.assign({}, state.bomDescription, obj)
  
}

export const DELETEBOMDESCRIPTION = (state) => {
  
  state.bomDescription = {};
  
}

export const SETSELECTEDPARTBOMROW = (state, obj) => {

  state.selectedPartBomRow = Object.assign({}, state.selectedPartBomRow, obj)
}
export const DELETESELECTEDPARTBOMROW = (state) => {

  state.selectedPartBomRow = {};
}
export const SETSELECTEDDOCUMENT = (state, obj) => {

  state.selectedDocument = Object.assign({}, state.selectedDocument, obj)
}
export const DELETESELECTEDDOCUMENT = (state) => {

  state.selectedDocument = {};
}

export const ISBOMINPROJECT = (state, value) => {

  state.isBomInProject = value;
}


export const SELECTTREEFOLDERITEM = (state, value) => {

  state.selectedTreeFolderItem = value;
}
export const SELECTTREEFOLDERITEMOBJECT = (state, value) => {

  state.selectedTreeFolderItemObject = value;
}
export const RELOADAFTERDELETETREEFOLDERITEM = (state, value)=>{
  state.reloadAfterDeleteTreeFolderItem = value;
}

export const SETELEMENTFOLDERPROJECT = (state, value) => {

  state.elementFolderProject = value;
}

export const DELETEFOLDERMAPPING = (state) => {

  state.categoryFolderMapping = [];
}

export const CREATESUBFOLDERFORM = (state, obj) => {

  state.subfolderForm = Object.assign({}, state.subfolderForm, obj)
}
export const CREATEVARIANTFOLDERFORM = (state, obj) => {

  state.variantFolderForm = Object.assign({}, state.variantFolderForm, obj)
}

export const SETSELECTEDBOMROW = (state, obj) => {

  state.selectedBomRow.push(obj);
  
}
export const DELETESELECTEDBOMROW = (state) => {
  
  state.selectedBomRow = [];
  
}

export const SETVARIANTS = (state, arr) => {
  
  state.variants = [];
  
  for (let i = 0, lei = arr.length; i < lei; i++){

    

    let obj = {
      name: arr[i].name,
      variantId: arr[i].variantId,
    }
    state.variants.push(obj);
  }
  
  
}

export const SETDELEGATEDRESOURCE = (state, value) => {

  state.delegatedResource = value;

}

export const ISBOM = (state, value) => {
  
  state.isBom = value;
  
}

export const IMPORTBOMTYPEFORM = (state, obj) => {
  state.importBomTypeForm = Object.assign({}, state.importBomTypeForm, obj)
}

export const CREATEBOMVARIANTFORM = (state, obj) => {
  state.createBomVariantForm = Object.assign({}, state.createBomVariantForm, obj)
}

export const CREATEBOMPARTOBJECTFORM = (state, obj) => {
  state.bomPartObjectForm = Object.assign({}, state.bomPartObjectForm, obj)
}

export const SETCHECKBOXVARIANT = (state, obj) => {
  state.checkboxVariant = Object.assign({}, state.checkboxVariant, obj)
}
export const REMOVECHECKBOXVARIANT = (state) => {
  state.checkboxVariant = null;
}

export const SETSELECTEDSEARCHPARTROWS = (state, obj) => {

  state.selectedSearchPartRows = Object.assign({}, state.selectedSearchPartRows, obj)
  
}

export const DELETEALLSELECTEDSEARCHPARTROWS = (state) => {

  state.selectedSearchPartRows = null;

}

export const SETIPCIMAGESTATUS = (state, value) => {

  state.noIpcImage = value;
}


// WEBPACK FOOTER //
// ./src/store/mutations.js